import { proxy } from 'valtio';

import { Highlighted, Speaking } from '@features/video/types';

// Горячие значения плиток по умолчанию, когда их никто не ведет (истории, превью):
// никто не говорит, курсор ни над кем. Все прокси valtio носят суффикс Proxy: такое поле
// меняют по ключам, а в компоненте читают через useSnapshot
export const NO_SPEAKING_PROXY = proxy<Speaking>({});
export const NO_HOVER_PROXY = proxy<Highlighted>({});

// Курсор над игроком: один ключ, прежний снимаем
export function setHighlighted(hoverProxy: Highlighted, userId: string | null): void {
  Object.keys(hoverProxy).forEach((id) => {
    if (id !== userId) delete hoverProxy[id];
  });
  if (userId) hoverProxy[userId] = true;
}
